module.exports = __webpack_public_path__ + "img/OBUHaveOrder_04.de6ae437.png";